var Vendd = (function (Vendd) {
    'use strict';


    Vendd.MessageBus.subscribe(Vendd.MyConfigurations.Messages.GetModel, Vendd.MyConfigurations, function (envelope) {
        function onSuccess(response) {
            if (response.success) {
                Vendd.MessageBus.publishAsync(Vendd.MyConfigurations, new Vendd.MyConfigurations.Messages.GetModelSuccess(response));
            } else {
                Vendd.MessageBus.publishAsync(Vendd.MyConfigurations, new Vendd.MyConfigurations.Messages.GetModelFailed(response));
            };
        }

        function onFailure(response) {
            Vendd.MessageBus.publishAsync(Vendd.MyConfigurations, new Vendd.MyConfigurations.Messages.GetModelFailed(response));
        }
        var options = {
            method: 'POST',
            url: 'api/MyConfigurations/GetModel',
            onSuccess: onSuccess,
            onFailure: onFailure
        };

        Vendd.Service.call(options);
    });

    Vendd.MessageBus.subscribe(Vendd.MyConfigurations.Messages.Remove, Vendd.MyConfigurations, function (envelope) {
        function onSuccess(response) {
            Vendd.MessageBus.publishAsync(Vendd.MyConfigurations, new Vendd.MyConfigurations.Messages.RemoveSuccess());
        }
        function onFailure(response) {
            Vendd.MessageBus.publishAsync(Vendd.MyConfigurations, new Vendd.MyConfigurations.Messages.RemoveFailed(response));
        }

        var options = {
            url: 'api/MyConfigurations/Remove',
            data: {
                Id: envelope.message.data.Id
            },
            onSuccess: onSuccess,
            onFailure: onFailure
        };

        Vendd.Service.call(options);
    });

    Vendd.MessageBus.subscribe(Vendd.MyConfigurations.Messages.ConfirmInventory, Vendd.MyConfigurations, function (envelope) {
            function onSuccess(response) {
                Vendd.MessageBus.publishAsync(Vendd.MyConfigurations, new Vendd.MyConfigurations.Messages.ConfirmInventorySuccess());
            }
            function onFailure(response) {
                Vendd.MessageBus.publishAsync(Vendd.MyConfigurations, new Vendd.MyConfigurations.Messages.ConfirmInventoryFailed(response));
            }

            var options = {
                url: 'api/MyConfigurations/ConfirmInventory',
                onSuccess: onSuccess,
                onFailure: onFailure
            };


            Vendd.Service.call(options);
        });
    
	return Vendd;

})(Vendd || {});